<template>
	<div class="container-fluid">
		<div class="row d-flex justify-content-center mt-2">
			<div class="col-6 text-center">
				<div class="h4">
					{{$store.getters.user.nev}}
				</div>
			</div>
			<div class="col-6 text-center">
				<div class="h5">
					Belépési név: {{$store.getters.user.loginnev}}
				</div>
			</div>
		</div>
		<div class="col-12">
			<div class="row d-flex justify-content-center">
				<div class="col-12 col-sm-12 col-md-8 col-lg-8">
					<div class="mui-textfield mui-textfield m-2">
					    <input type="password" v-model="pass1">
					    <label>Új jelszó</label>
					</div>
				</div>
				<div class="col-12 col-sm-12 col-md-8 col-lg-8">
					<div class="mui-textfield mui-textfield m-2">
					    <input type="password" v-model="pass2">
					    <label>Új jelszó mégegyszer</label>
					</div>
				</div>
			</div>
			<div class="row d-flex justify-content-center">
				<div class="col text-center">
					<button class="btn btn-lg btn-outline-primary m-2" :disabled="!verify_pass" @click.prevent="save">
						<span v-show="verify_pass">
							Mentés
						</span>
						<span v-show="!verify_pass">
							A jelszavak nem egyeznek
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'profile',
	data(){
		return {
			pass1: ``,
			pass2: ``
		}
	},
	methods: {
		save(){
			this.$Progress.start()
			this.req.post(`/managers/profile`,{
				user: {
					azon: this.$store.getters.user.azon,
					pass_new: this.pass1
				}
			})
				.then(res => {
	    			console.log(res.data)
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			console.log(err)
	    			this.$Progress.fail()
	    		})
		}
	},
	computed: {
		verify_pass(){
			return (this.pass1 === this.pass2) && (this.pass1 != `` && this.pass2 != ``)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/profile.vue